<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-building icon"></i>
        Establecimientos
      </div>
      
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administratorHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'stablishment'}">
                <span>
                 <i class="fas fa-building icon"></i>
                  Establecimientos
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">

          <createStablishment 
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeStablishmentList="chargeStablishmentList"
          :stablishment_id="stablishment_id">
          </createStablishment>
          <b-button type="is-primary is-small" @click="openBasic()">Crear Establecimiento</b-button>

          <b-table type="is-primary"
         :data.sync="listStablishment.data"
            :loading="loading"            
            :is-fullwidth="true"
          
            paginated
            backend-pagination
            :total="listStablishment.total"
            :per-page="listStablishment.per_page"
            @page-change="chargeStablishmentList"
          >
            <template slot-scope="props">
              <b-table-column searchable field="name" label="Nombre">{{ props.row.name }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import createStablishment from '../../../../components/manteiners/stablishment/create';
import {StablishmentService} from '../../../../services/models/stablishment'

export default {
  components: {
    PlantillaContenido,
    createStablishment
  },
  data() {
    return {
      stablishment_id: null,
      listStablishment: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeStablishmentList();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.stablishment_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.stablishment_id = id;
      this.isComponentModalActive = true;
    },
    async chargeStablishmentList() {
      this.loading = true;
      this.listStablishment = [];
      const {data} = await StablishmentService.getAll()
      this.listStablishment = data;
      this.loading = false;
    }
  },
  
};
</script>

